import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {FulfillmentLineType} from "../../../oms/types/fulfillment-line.type";

export class FulfillmentLineTypesMultiSelectListComponent implements IController {

  fulfillmentLineTypes: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;
  private queryString: any;

  constructor() {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = Object.keys(FulfillmentLineType);
    }
  }

  $onChanges(changes) {
    if (changes.fulfillmentLineTypes) {
      this.selectedKeys = {};
      _.forEach(this.fulfillmentLineTypes, (type) => {
        this.selectedKeys[type] = true;
      })
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggle(option, isSelected) {
    this.onChange({
      fulfillmentLineTypes: isSelected ? _.concat(this.fulfillmentLineTypes || [], [option]) :
        _.filter(this.fulfillmentLineTypes, (type) => {
          return type !== option;
        })
    });
  }

  onReset() {
    this.onChange({fulfillmentLineTypes: []});
  }

  submitQuery(query) {
    this.queryString = query;
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentLineTypesMultiSelectList', {
    bindings: {
      fulfillmentLineTypes: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./fulfillment-line-types-multi-select-list.html').default,
    controller: FulfillmentLineTypesMultiSelectListComponent
  });
